/** Stable card routes use IDs, never display names that can change or repeat. */
export const CARD_TABS = {
  credits: "Credits",
  offers: "Offers",
  benefits: "Benefits",
  rewards: "Earning rates",
  edit: "Edit card",
} as const;

export type CardTab = keyof typeof CARD_TABS;

export function cardIdFromQuery(value: string | null): number | null {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
}

export function cardTabFromQuery(value: string | null): CardTab {
  return value && Object.hasOwn(CARD_TABS, value) ? value as CardTab : "credits";
}

export function cardDetailHref(id: number, tab: CardTab = "credits"): string {
  const query = new URLSearchParams({ card: String(id) });
  if (tab !== "credits") query.set("cardTab", tab);
  return `/cards?${query.toString()}`;
}
